import { createSuitMixin as t } from "../mixins/suit.js";
export default {
  name: "AisPoweredBy",
  mixins: [t({
    name: "PoweredBy"
  })],
  props: {
    theme: {
      default: "light",
      validator: function validator(t) {
        return -1 !== ["light", "dark"].indexOf(t);
      }
    }
  },
  computed: {
    algoliaUrl: function algoliaUrl() {
      return "https://www.algolia.com/?utm_source=vue-instantsearch&utm_medium=website&utm_content=" + (location ? location.hostname : "") + "&utm_campaign=poweredby";
    }
  }
};